import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { CollectionsEntity } from "./collections.entity";
import { CollectionsService } from "./collections.service";
import { CollectionsController } from "./collections.controller";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { SaleOrderService } from "@gtpl/shared-services/sale-management";

@Module({
    imports:[
        TypeOrmModule.forFeature([CollectionsEntity])
    ],
    controllers:[CollectionsController],
    providers:[ApplicationExceptionHandler,CollectionsService,SaleOrderService]
})
export class CollectionsModule{}